import React, { useContext, useEffect, useState } from "react";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import { Bus, IBusList, api } from "../../../logic/api";
import { BusListItem } from "./BusListItem";
import { Button } from "@mui/material";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import { ProgressDialog } from "../../../components/notifications/progressDialog/progressDialog";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { BusEdit } from "./BusEdit";
import NotFoundPage from "../../error/NotFoundPage";
import { useTranslation } from "react-i18next";

export const BusManager: React.FC = () => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    if (session?.current?.site?.preferences.bus_walkaround_enabled != true && session?.current?.site?.preferences.wmb_enabled != true) {
        return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")} />
    }

    const [listBusesParams, setListBusesParams] = useState<IBusList>({
        includeInactive: false,
        paging: {
            offset: 0,
            limit: 0,
        }
    });

    const [selectedBus, setSelectedBus] = useState<Bus | null>(null);
    const [showBusEdit, setShowBusEdit] = useState(false);

    const refreshView = () => setListBusesParams({ ...listBusesParams });

    const setActive = api.hooks.bus.setActive();

    useEffect(() => {
        refreshView();
        setSelectedBus(null);
        setShowBusEdit(false);
    }, [session.current.site]);


    return <div style={{ width: "100%", maxWidth: 1200, display: "inline-block" }}>
        <div style={{ textAlign: "left" }}>
            <div style={flex.flexRows}>
                <div style={flex.flexFill}>
                    <h2>{t("walkarounds.manageBuses")}</h2>
                </div>

            </div>
            <div style={{ height: 50 }}></div>
            <PagedDataView<IBusList, Bus>
                apiHook={api.hooks.bus.list}
                parameters={listBusesParams}
                renderItem={(item) => {
                    return <BusListItem key={item.id} item={item}
                        onEdit={() => {
                            setSelectedBus(JSON.parse(JSON.stringify(item)));
                            setShowBusEdit(true);
                        }}
                        onDelete={() => {
                            if (!item.id) { return }
                            setActive.send(session.current.context, {
                                active: false,
                                id: item.id
                            }, () => {
                                refreshView();
                            });
                        }}
                        onRestore={() => {
                            if (!item.id) { return }
                            setActive.send(session.current.context, {
                                active: true,
                                id: item.id
                            }, () => {
                                refreshView();
                            });

                        }}
                    ></BusListItem>
                }}

            >
                <div style={{ padding: 20, backgroundColor: "#eee" }}>
                    {t("walkarounds.noBuses")}
                </div>
            </PagedDataView>

            <Button
                style={{ marginLeft: 20, marginTop: 20, width: 200 }}
                variant="contained"
                color="secondary"
                onClick={() => {
                    setSelectedBus({
                        reg: "",
                        active: true,
                        isVOR: false,
                        distanceUnit: "miles"
                    });
                    setShowBusEdit(true);
                }}>{t("walkarounds.ADDNEW")}</Button>

            <ProgressDialog status={setActive.status}></ProgressDialog>

            <ErrorDialog err={setActive.err}></ErrorDialog>


            <BusEdit
                show={showBusEdit}
                bus={selectedBus}
                onClose={(didUpdate, wa) => {
                    if (didUpdate != true || wa == null) {
                        setShowBusEdit(false);
                    } else {
                        setSelectedBus(wa);
                        setShowBusEdit(false);
                        refreshView();
                    }
                }}>
            </BusEdit>
        </div>
    </div>;
}
